import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { motion, useReducedMotion, useScroll } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { CTABand } from "../components/CTABand";
import { ParallaxImage } from "../components/ParallaxImage";
import { BLOG_POSTS } from "../data/blog";
import { IMAGES } from "../data/images";
import { EASE } from "../utils/motion";
export function BlogPost() {
  const {
    slug
  } = useParams();
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll();
  const index = BLOG_POSTS.findIndex(p => p.slug === slug);
  if (index === -1) return <Navigate to="/news/blog" replace data-id="element-696" data-mp="36hvoapew85x1" />;
  const post = BLOG_POSTS[index];
  const next = BLOG_POSTS[(index + 1) % BLOG_POSTS.length];
  return <>
      <motion.div aria-hidden="true" style={{
      scaleX: reduce ? 0 : scrollYProgress
    }} className="fixed inset-x-0 top-20 z-40 h-[2px] origin-left bg-[#c5233d]" data-id="element-697" data-mp="14nd6rklhgom5" />
      <main className="bg-[#fbfaf6] pt-28" data-id="element-698" data-mp="11526m06oxft8">
        <article data-id="element-699" data-mp="114amblijn4i9">
          <header className="mx-auto max-w-[900px] px-5 pb-12 pt-8 md:px-9" data-id="element-700" data-mp="113r1nx1ie20j">
            <Link to="/news/blog" className="group inline-flex items-center gap-2 text-sm font-semibold text-[#4f5963] hover:text-[#061f38]" data-id="element-701" data-mp="164yb00jav99b"><ArrowLeftIcon size={15} className="transition-transform duration-200 group-hover:-translate-x-1" data-id="element-702" data-mp="s6gr6dwimgwo" /> All posts</Link>
            <motion.div initial={{
            opacity: 0,
            y: reduce ? 0 : 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: reduce ? 0.01 : 0.7,
            ease: EASE
          }} data-id="element-703" data-mp="1ktb9b45v146z">
              <p className="mt-10 text-xs font-semibold tracking-[0.16em] text-[#bb1e35]" data-id="element-704" data-mp="1otv4w3asbzr0">{post.category.toUpperCase()} · {post.readMinutes} MIN READ</p>
              <h1 className="mt-5 text-4xl font-medium leading-[0.98] tracking-[-0.06em] md:text-6xl" data-id="element-705" data-mp="1g1t5m8cgcpib">{post.title}</h1>
              <p className="mt-6 text-xl leading-8 text-[#4f5963]" data-id="element-706" data-mp="23qvx07ww1wq0">{post.excerpt}</p>
              {post.status === "draft" && <p className="mt-6 w-fit border border-[#cfcac0] px-3 py-1.5 text-xs text-[#6b7378]" data-id="element-707" data-mp="28k6wtp3a9d8f">Draft written from MCC-published information. Pending MCC approval.</p>}
            </motion.div>
          </header>
          <div className="mx-auto max-w-[1200px] px-5 md:px-9" data-id="element-708" data-mp="2dgaxc2dy8jvd">
            <ParallaxImage src={post.image} alt="" className="aspect-[16/9]" reveal="inset" priority data-id="element-709" data-mp="28few5wkzfbtn" />
          </div>
          <div className="mx-auto max-w-[720px] space-y-8 px-5 py-20 md:px-9" data-id="element-710" data-mp="23gk5y9koqkzi">
            {post.body.map(b => <section key={b.text.slice(0, 24)} data-id="element-711" data-mp="1zh2zpdxfpjta">
                {b.heading && <h2 className="mb-3 text-2xl font-medium tracking-[-0.04em]" data-id="element-712" data-mp="1uo0b7k7il0jy">{b.heading}</h2>}
                <p className="text-lg leading-8 text-[#3d4b57]" data-id="element-713" data-mp="1pp5h3m43jpkj">{b.text}</p>
              </section>)}
          </div>
        </article>

        {next.slug !== post.slug && <Link to={`/news/blog/${next.slug}`} className="group block border-t border-[#dedbd3] bg-[#f2f0eb]" data-id="element-714" data-mp="1fsalpc34e5ah">
            <div className="mx-auto flex max-w-[1440px] items-center justify-between gap-6 px-5 py-12 md:px-9" data-id="element-715" data-mp="1bpxk8zveotji">
              <div data-id="element-716" data-mp="3ncr7g8k20oy8">
                <p className="text-xs font-semibold tracking-[0.18em] text-[#bb1e35]" data-id="element-717" data-mp="3nd9f01c62plg">NEXT</p>
                <p className="mt-2 text-2xl font-medium tracking-[-0.04em] transition-colors duration-200 group-hover:text-[#bb1e35] md:text-4xl" data-id="element-718" data-mp="3rdb4zd8jhukw">{next.title}</p>
              </div>
              <ArrowRightIcon size={24} className="shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-719" data-mp="56laodoxy6gu" />
            </div>
          </Link>}
      </main>
      <CTABand title="Ready to talk about your child’s next step?" image={IMAGES.campus} data-id="element-720" data-mp="38nv3aml4bw2w" />
    </>;
}